import { Star } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

const testimonials = [
  {
    name: "Marcus Okonkwo",
    role: "Security Consultant, Lagos",
    initials: "MO",
    quote: "I got an alert about the Port Harcourt pipeline incident 35 minutes before Reuters published it. That head start let me brief my client and relocate their team before the area was locked down.",
    stars: 5,
  },
  {
    name: "Elena Vasquez",
    role: "Freelance Journalist, Bogotá",
    initials: "EV",
    quote: "I used to spend 3 hours every morning checking 12 different OSINT sources. Now I open one tab. The signal chain alone is worth 10x the subscription.",
    stars: 5,
  },
  {
    name: "Dr. Kenji Tanaka",
    role: "Disaster Response, INGO Tokyo Office",
    initials: "KT",
    quote: "During the Taiwan Strait tensions last month, we had real-time missile trajectory data while CNN was still running 'breaking news' banners with no details. Our field teams were already moving.",
    stars: 5,
  },
  {
    name: "Amira Ben-David",
    role: "Travel Risk Analyst, Tel Aviv",
    initials: "AB",
    quote: "The siren alerts saved us twice — once in Ashkelon and once near Haifa. My family now refuses to travel without checking this platform first. It's not optional anymore, it's essential.",
    stars: 5,
  },
  {
    name: "Pierre Moreau",
    role: "Supply Chain Manager, Lyon",
    initials: "PM",
    quote: "When the Red Sea shipping crisis hit, I saw the disruption forming 48 hours before our logistics provider flagged it. We rerouted €2M in cargo before costs spiked. Paid for itself 1000x over.",
    stars: 5,
  },
  {
    name: "Fatima Al-Rashidi",
    role: "Humanitarian Coordinator, Amman",
    initials: "FA",
    quote: "We coordinate aid convoys across three conflict zones. The real-time conflict map and safe route planner have become our daily operations tool. Nothing else gives us this level of granularity.",
    stars: 5,
  },
];

const Testimonials = () => {
  return (
    <section className="border-t border-border bg-card/30 py-12 md:py-16">
      <div className="container mx-auto px-4">
        <div className="mb-8 text-center">
          <h2 className="text-xl md:text-2xl font-bold text-foreground mb-2">
            What our users say
          </h2>
          <p className="text-sm text-muted-foreground">
            Used by professionals who cannot afford to miss critical signals
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="rounded-lg border border-border bg-card p-5 flex flex-col gap-3"
            >
              <div className="flex gap-0.5">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <Star key={i} className="h-3.5 w-3.5 fill-primary text-primary" />
                ))}
              </div>
              <p className="text-sm text-foreground/90 leading-relaxed italic">
                "{t.quote}"
              </p>
              <div className="mt-auto flex items-center gap-2.5 pt-2 border-t border-border/50">
                <Avatar className="h-8 w-8">
                  <AvatarFallback className="text-[11px] font-semibold bg-primary/10 text-primary">
                    {t.initials}
                  </AvatarFallback>
                </Avatar>
                <div>
                  <p className="text-xs font-semibold text-foreground">{t.name}</p>
                  <p className="text-[11px] text-muted-foreground">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
